import React from "react";
import zlippIcon from "../../Assets/Images/Home/Zlipp-icon.png";
import appStore from "../../Assets/Images/Home/app-store.png";
import playStore from "../../Assets/Images/Home/play-store.png";
import notebookIcon from "../../Assets/Images/Home/notebook-icon.svg";
import "./Download.scss";

const IOS_URL = "https://apps.apple.com/in/app/zlipp/id6471843198";
const ANDROID_URL =
  "https://play.google.com/store/apps/details?id=com.zlipp&pli=1";
const STUDENT_MANUAL_URL = `${process.env.PUBLIC_URL}/docs/Student_Manual.pdf`;

const Download = () => {
  return (
    <div className="download-page">
      <div className="download-page__inner">
        <img src={zlippIcon} className="download-page__logo" alt="Zlipp" />

        <h1 className="download-page__title">Download the Zlipp App</h1>
        <p className="download-page__subtitle">
          Get Zlipp on your device or read the student manual below.
        </p>

        <div className="download-page__options">
          <a
            className="download-card download-card--ios"
            href={IOS_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="download-card__badge">iOS</span>
            <h2 className="download-card__heading">iPhone &amp; iPad</h2>
            <p className="download-card__text">
              Install Zlipp from the App Store for iOS devices.
            </p>
            <img
              src={appStore}
              className="download-card__store-img"
              alt="Download on the App Store"
            />
          </a>

          <a
            className="download-card download-card--android"
            href={ANDROID_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="download-card__badge">Android</span>
            <h2 className="download-card__heading">Android phones &amp; tablets</h2>
            <p className="download-card__text">
              Install Zlipp from Google Play for Android devices.
            </p>
            <img
              src={playStore}
              className="download-card__store-img"
              alt="Get it on Google Play"
            />
          </a>
        </div>

        <div className="download-page__manual">
          <div className="download-manual">
            <img
              src={notebookIcon}
              className="download-manual__icon"
              alt=""
              aria-hidden
            />
            <div className="download-manual__content">
              <span className="download-manual__badge">Guide</span>
              <h2 className="download-manual__heading">Student Manual</h2>
              <p className="download-manual__text">
                Step-by-step instructions for using the Zlipp app as a student.
              </p>
            </div>
            <div className="download-manual__actions">
              <a
                className="download-manual__btn download-manual__btn--primary"
                href={STUDENT_MANUAL_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                View manual
              </a>
              <a
                className="download-manual__btn download-manual__btn--secondary"
                href={STUDENT_MANUAL_URL}
                download="Zlipp-Student-Manual.pdf"
              >
                Download PDF
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Download;
